import { WorkspaceShell } from "@/components/WorkspaceShell";

export default function PlatformShell() {
  return <WorkspaceShell />;
}
